import { useQuery } from 'react-query';
import { CACHE_1_HOUR_MS } from '../../config/utils/cacheUtils';
import { MONEY_COLLECTION_PAYMENT_TYPE } from '../../interfaces/moneyCollection.interface';
import { apiRQ } from '../api';

export interface MoneyCollectionTrader {
  id: number;
  name: string;
  description: string;
}

export interface MoneyCollectionFormData {
  paymentTypes: MONEY_COLLECTION_PAYMENT_TYPE[];
  traderTypes: MoneyCollectionTrader[];
}

const getMoneyCollectionFormData = async (): Promise<MoneyCollectionFormData> => {
  const resp = await apiRQ.get<MoneyCollectionFormData>('/form-data/money-collection');

  return resp.data;
};

export const useFormMoneyCollection = () => {
  return useQuery<MoneyCollectionFormData, Error>(['useFormMoneyCollection'], () => getMoneyCollectionFormData(), {
    cacheTime: CACHE_1_HOUR_MS,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
